<script setup lang="ts">
// Fix relative URLs for GraphQL endpoints
const graphqlClients = useRuntimeConfig().public["graphql-client"]?.clients;
if (graphqlClients) {
	Object.entries(graphqlClients).forEach(([key, client]) => {
		const apiHost = typeof client === "string" ? client : client?.host;
		if (apiHost) {
			// check if the host is a relative URL and convert it to an absolute URL
			if (!/^https?:\/\//i.test(apiHost) && typeof window !== "undefined" && window.location) {
				const newHost = window.location.origin.replace(/\/$/, "") + (apiHost.startsWith("/") ? "" : "/") + apiHost;
				// If the host is relative, convert it to an absolute URL
				useGqlHost(newHost, key);
			}
		}
	});
}

// Scroll fonctionality
const showScrollTop = ref(false);

const handleScroll = () => {
	if (window.scrollY > 200) {
		showScrollTop.value = true;
	}
	else {
		showScrollTop.value = false;
	}
};

const scrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});
};

onMounted(() => {
	window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
	window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
	<div v-if="showScrollTop"
		class="back-to-top"
		@click="scrollToTop" />
</template>

<style scoped lang="scss">
@import "@/assets/styles/utils/mixins";
@import "@/assets/styles/utils/variables";

.back-to-top {
  overflow: hidden;
  border-radius: 50px;
  color: transparent;
  clear: both;
  position: fixed;
  cursor: pointer;
  display: block;
  border: none;
  background: #fff;
  right: 25px;
  bottom: 50px;
  height: 50px;
  width: 50px;
  box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.25);
  font-size: 0px;
  outline: 0 !important;
  z-index: 9999;
  transition: all 0.3s ease-in-out;

  @include desktop {
    right: 25px;
    bottom: 50px;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    vertical-align: middle;
    border-bottom: solid 10px #20164D;
    border-left: solid 10px transparent;
    line-height: 0;
    border-right: solid 10px transparent;
    height: 0;
    margin: 18px auto 0;
    width: 0;
    border-radius: 20px;
    transition: all 0.5s;
    position: relative;
  }

  &::after {
    border-bottom-color: #fff;
    position: relative;
    top: -24px;
  }
}
</style>
